import type { FC } from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';

import { usePopover } from 'src/hooks/use-popover';
import { RootState } from "src/store";

import { useSelector } from "react-redux";
import { AccountPopover } from './account-popover';
import { Employee } from 'src/interfaces/employee.interface';
import { getInitials } from 'src/utils/get-initials';

export const AccountButton: FC = () => {
  const popover = usePopover<HTMLButtonElement>();

  const employee: Employee = useSelector((state: RootState) => state.employeeAccount.employee);

  return (
    <>
      <Box
        component={ButtonBase}
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        sx={{
          alignItems: 'center',
          display: 'flex',
          borderWidth: 2,
          borderStyle: 'solid',
          borderColor: 'divider',
          height: 40,
          width: 40,
          borderRadius: '50%'
        }}
      >
        <Avatar
          sx={{
            height: 32,
            width: 32
          }}
          src={employee?.photo}
        >
          {getInitials(employee?.fullName)}
        </Avatar>
      </Box>
      <AccountPopover
        employee={employee}
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
